// src/components/Navbar.jsx
import { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { to: '/',        label: 'Home'             },
  { to: '/book',    label: 'Book Maintenance' },
  { to: '/about',   label: 'About'            },
  { to: '/contact', label: 'Contact'          },
  { to: '/shop',    label: 'Shop'             },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => { setMenuOpen(false); }, [pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 bg-white transition-all duration-300 ${scrolled ? 'shadow-md' : 'shadow-sm'}`}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <nav className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 font-bold text-xl text-gray-900">
            <svg viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
              <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z" />
              <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" />
            </svg>
            BalconyGreen
          </Link>

          {/* Desktop links */}
          <ul className="hidden md:flex items-center gap-1">
            {NAV_LINKS.map(({ to, label }) => (
              <li key={to}>
                <NavLink to={to} end={to === '/'}
                  className={({ isActive }) =>
                    `px-4 py-2 text-sm font-medium transition-colors duration-150
                     ${isActive ? 'text-[#2e7d32]' : 'text-gray-600 hover:text-[#2e7d32]'}`}>
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* Admin button */}
          <div className="hidden md:block">
            <Link to="/admin" className="px-5 py-2 bg-[#2e7d32] text-white text-sm font-semibold rounded-lg hover:bg-[#1b5e20] transition-colors duration-200">
              Admin
            </Link>
          </div>

          {/* Mobile hamburger */}
          <button onClick={() => setMenuOpen(o => !o)} className="md:hidden p-2 text-gray-600 hover:text-[#2e7d32]" aria-label="Toggle menu">
            {menuOpen
              ? <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
              : <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
            }
          </button>
        </nav>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <ul className="flex flex-col px-4 py-3 gap-1">
            {NAV_LINKS.map(({ to, label }) => (
              <li key={to}>
                <NavLink to={to} end={to === '/'}
                  className={({ isActive }) =>
                    `block px-4 py-2.5 rounded-lg text-sm font-medium transition-colors
                     ${isActive ? 'text-[#2e7d32] bg-green-50' : 'text-gray-600 hover:bg-gray-50'}`}>
                  {label}
                </NavLink>
              </li>
            ))}
            <li>
              <Link to="/admin" className="block px-4 py-2.5 rounded-lg text-sm font-semibold text-white bg-[#2e7d32] text-center mt-1">Admin</Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
